import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { EntityDirectoryPage } from '@texas/components/shared/entityDirectory/EntityDirectoryPage';
import { BodyOverride } from '@texas/components/shared/BodyOverride';
import {
  configurationPageStyles,
  getConfigurationContentStyle,
} from '@texas/resources/theme/styles/configuration';

interface ConfigurationPageProps {
  action?: React.ReactNode;
  children: React.ReactNode;
  description?: string;
  editorSurface?: boolean;
  title: string;
  toolbar?: React.ReactNode;
}

export function ConfigurationPage({
  action,
  children,
  description,
  editorSurface = false,
  title,
  toolbar,
}: ConfigurationPageProps) {
  const { t } = useTranslation();

  return (
    <BodyOverride>
      <EntityDirectoryPage
        actions={action}
        description={description ?? t('configuration.pageDescription')}
        eyebrow={t('actionBar.configuration')}
        title={title}
      >
        {toolbar && <Flex sx={configurationPageStyles.toolbar}>{toolbar}</Flex>}

        <Box sx={getConfigurationContentStyle(!!toolbar, editorSurface)}>
          {children}
        </Box>
      </EntityDirectoryPage>
    </BodyOverride>
  );
}
